import React, { PureComponent } from 'react';

import styled from 'styled-components';

import { Colors } from '@shared/interfaces/themes';

type DividerProps = {
  className?: string;
  color?: keyof Colors;
  height?: number;
};

class Divider extends PureComponent<DividerProps> {
  static defaultProps = {
    color: 'alto',
    height: 1,
  };

  render() {
    const { className, ...props } = this.props;
    
    return <div role="separator" className={className} {...props} />;
  }
}

const styledDivider = styled(Divider)`
  height: ${props => props.height}px;
  width: 100%;
  background-color: ${props => props.theme.colors[props.color]};
`;

export default styledDivider;
